<template>
  <div>
    <v-toolbar
      elevation="0"     
    >
    <v-icon large style="margin-right:10px;">mdi-share-variant</v-icon>
      <v-toolbar-title>
        Compartir contenido
      </v-toolbar-title>
    </v-toolbar>
    <div style="padding: 0 10px">
      <search
        :onSearch="(v) => { search = v}"
        :showClear="true"
        label="Filtrar"
        :maxWidth="1000"
      />
    </div>
    <v-progress-linear indeterminate v-if="loading" />
    <v-container v-else-if="editedItem"
          style="margin:0;padding: 0;"
    >
      <v-row
          style="margin:0;padding: 0;"
      >
        <v-col
          cols="12"
          sm="12"
          md="12"
          style="margin:0;padding: 0;"
        >  
          <v-container fluid>
            <!--p>{{ editedItem }}</p-->
            <v-checkbox
            v-for="(item, index) of shareContentConfig.filter(x => x.TargetName.toUpperCase().indexOf(search.toUpperCase()) >= 0)"
              :key="index"
              v-model="editedItem"
              :label="item.TargetName"
              :value="item.ID"
              hide-details
            />
          </v-container>
        </v-col>
      </v-row>
    </v-container>
    <action-buttons
      v-if="editedItem"
      :id="editedID"
      :onSaveItem="handleSave"
      :onClose="handleClose"
      :locale="locale"
    />
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import api from '@/services/api'
  import ActionButtons from '@/components/ActionButtons'
  import Search from '@/components/Search'
  export default{
    name: 'ShareContentForm',
    components: {
      ActionButtons,
      Search,
    },
    props: {
      shareContentConfig: {
        type: Array,
        default: null,
      },
      editedID: {
        type: String,
        default: null
      },
      onClose: {
        type: Function,
        required: true
      },
      contentType: {
        type: String,
        required: true,
      },
      contentTypeID: {
        type: String,
        required: true,
      },
    },
    data () {
      return {
        loading: false,
        editedItem: null,
        search: '',
      }
    },
    computed: {
      ...mapState('app',['locale']),
    },
    watch: {
      editedID () {
        this.handleGetData()
      },
    },
    mounted () {
      this.handleGetData()
    },
    methods: {
      handleGetData () {
        this.loading = true
        this.editedItem = null
        api.getAllWithoutLimit('dviewcontent', `private/${this.contentType === 'media' ? 'media' : 'messages'}/${this.contentTypeID}/${this.editedID}/share-content-target`)
          .then(response => {
            this.editedItem = response.map(item => item.WorkspaceShareID)
            this.loading = false
          })
      },
      handleSave () {
        api.put('dviewcontent', `private/${this.contentType === 'media' ? 'media' : 'messages'}/${this.editedID}/share-content`, this.editedItem)
          .then(() => {   
            this.onClose()
          })
      },
      handleClose () {
        this.onClose()
      },
    }
  }
</script>
